import * as cjsm from "react-dom/client";export const { createRoot,hydrateRoot,version } = cjsm;export default cjsm.default ?? cjsm;